import React from 'react';
import { Mail, Phone, Linkedin, Instagram, Youtube, Facebook } from 'lucide-react';
import { contactData } from '../mock/landingData';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo-chico.png" 
                alt="Logo Chico da Inclusão" 
                className="h-12 w-auto"
              />
              <div>
                <h3 className="text-white font-bold text-lg">Chico da Inclusão</h3>
                <p className="text-xs text-gray-400">{t('header.subtitle')}</p>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                >
                  {t('header.nav.home')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('mission')}
                  className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                >
                  {t('header.nav.mission')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                >
                  {t('header.nav.services')}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-teal-400 transition-colors duration-200 text-sm"
                >
                  {t('header.nav.about')}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>{t('services.items.lectures.title')}</li>
              <li>{t('services.items.training.title')}</li>
              <li>{t('services.items.courses.title')}</li>
              <li>{t('services.items.events.title')}</li>
              <li>{t('services.items.consulting.title')}</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4">{t('footer.contactTitle')}</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Phone size={16} className="text-teal-400" />
                <span className="text-sm text-gray-400">{contactData.phone}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-teal-400" />
                <span className="text-sm text-gray-400">{contactData.email}</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-3 mt-6">
              <a
                href={contactData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors duration-200"
              >
                <Instagram size={18} />
              </a>
              <a
                href={contactData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors duration-200"
              >
                <Facebook size={18} />
              </a>
              <a
                href={`https://linkedin.com/company/${contactData.social.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors duration-200"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={`https://youtube.com/@${contactData.social.youtube}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors duration-200"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} {t('footer.copyright')}
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors duration-200">
                {t('footer.privacy')}
              </a>
              <a href="#" className="text-gray-400 hover:text-teal-400 transition-colors duration-200">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
